module.exports = __webpack_public_path__ + "img/Patent_5.8f0a6b8f.jpg";